import React, { Suspense } from 'react';
import { CutIcon, HistoryIcon, Pane } from 'evergreen-ui';
import { Outlet } from 'react-router-dom';
import { NavLinkButtons } from 'Shared';
import SuspenseSpinner from 'Utils/SuspenseSpinner';

export const messagesTabs = [
  { label: 'Метеосообщения', to: 'meteomessages', iconBefore: HistoryIcon },
  { label: 'Фрагменты', to: 'cut', iconBefore: CutIcon },
];

export const MessagesTabs = React.memo(() => (
  <Pane display="grid" gridTemplateRows="max-content 1fr" overflow="hidden">
    <NavLinkButtons buttons={messagesTabs} />

    <Suspense fallback={<SuspenseSpinner />}>
      <Outlet />
    </Suspense>
  </Pane>
));

MessagesTabs.displayName = 'MessagesTabs';
